import { mydtasClient } from "./mydtasClient";

export const mydtasService = {
  /** Tüm varsayılan menü öğelerini getirir */
  getDefaultMenu: () => mydtasClient.get("/menu/all"),

  /** Kullanıcının kısayollarını / menü tercihlerini getirir */
  getUserMenu: () => mydtasClient.get("/userMenu/all"),

  /** Tek bir kullanıcı menü öğesini ekler veya günceller */
  updateUserMenu: (dto) => mydtasClient.post("/userMenu/update", dto),

  /** Toplu sıralama / görünürlük güncelleme */
  updateUserMenuRange: (menuList) =>
    mydtasClient.post("/userMenu/update-range", { menuList }),

  /** Yetki kontrollü yönlendirme */
  navigate: (dto) => mydtasClient.post("/Navigation/go", dto),

  /** Kullanıcının bildirimlerini getirir */
  getNotifications: () => mydtasClient.get("/notification/my-notifications"),

  /** Filtrelenmiş bildirimler (search, sort, readStatus, projectName) */
  getNotificationsFiltered: (params) =>
    mydtasClient.get("/notification/my-notifications", { params }),

  /** Bildirimi okundu olarak işaretler */
  markNotificationAsRead: (id) =>
    mydtasClient.put(`/notification/mark-as-read/${id}`),

  /** Bir URL'den favicon getirir (base64) */
  getFavicon: (url) => mydtasClient.get("/favicon", { params: { url } }),
};
